import { Nullable } from "@/api/ApiClient";
import { WithCustomerInfo } from "./DocumentClientType";
import { WithReferenceCode } from "./ReferenceCodeType";

export interface InvoiceFormCore extends WithReferenceCode<WithCustomerInfo<{
    id: string | undefined,
    numero: number,
    sequence: string,
    invoice_key: string,
    tipo: string,
    nombre_factura: string,
    tel1: string,
    tel2: string,
    email: string,
    direccion: string,
    clientActivitycode: string,
    fecha: string,
    cerrada: boolean,
    porcenta_descuento: number,
    subtotal: number,
    discountCode: string,
    descuento: number,
    impuestos: number,
    impuestos_servicio: number,
    total: number,
    fair_id: string,
    anulada: boolean,
    tipo_identificacion: string,
    identificacion: string,
    pagada: boolean,
    status: string,
    saleCondition: number,
    es_apartado: boolean,
    exenta: boolean,
    with_user_info: boolean,
    exchange_rate: number,
    einvoice_status: number,
    edocument_status_payload: string,
    einvoice_kind: string,
    document_comments: string,
    customfields: any,
    info_references: string,
    otros_cargos: string,
    plazo: number,
    interest_exempt: boolean,
    activitycode: string,
    tax_regime: string,
    selected_logo: number,
    descuento_con_nota: boolean,
    bultos: number,
    shipping_carrier: string,
    clientId: string,
    client: any,
    currencyId: string,
    currency: any,
    recibeId: string,
    recibe: any,
    salemanId: string,
    saleman: any,
    invoiceProducts: any[]
    invoicePayments: any[]
    creditnotes: any[],
    debitnotes: any[],
    interestEntries: any[],
    apliedCreditnote: any,
    apliedDebitnote: any,
    user: string,
}>> { }

export type InvoiceFormData = Nullable<InvoiceFormCore>;
export const InvoiceRelatedAttributes: Array<keyof InvoiceFormData> = ["client", "currency", "recibe", "saleman", "invoiceProducts", "invoicePayments", "creditnotes", "debitnotes", "apliedCreditnote", "apliedDebitnote", "interestEntries"];